import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule} from '@angular/material/icon';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import { PerdidoComponent } from './componentes/perdido/perdido.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import {enableProdMode} from '@angular/core';
import { DatePipe } from '@angular/common';
import { PlacePickerModule } from 'ngx-place-picker';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BuscaCodigoAlumnoComponent } from './componentes/busca-codigo-alumno/busca-codigo-alumno.component';
import { CommonModule } from '@angular/common';
import { MapaComponent } from './componentes/mapa/mapa.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { FichaComponent } from './componentes/ficha/ficha.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { GraciasComponent } from './componentes/gracias/gracias.component';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import firebase from 'firebase/app';


import { AgmCoreModule } from '@agm/core';
import { AgmDrawingModule } from '@agm/drawing';
import { MatRadioModule } from '@angular/material/radio';




enableProdMode();

@NgModule({
  declarations: [
    AppComponent,
    PerdidoComponent,
    BuscaCodigoAlumnoComponent,
    MapaComponent,
    FichaComponent,
    SafeUrlPipe,
    GraciasComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AngularFireFunctionsModule,
    AngularFireStorageModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    PdfViewerModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatToolbarModule,
    AngularFireModule.initializeApp(environment.firebase),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AngularFireDatabaseModule,
    PlacePickerModule,
    HttpClientModule,
    NgxExtendedPdfViewerModule,
    AgmDrawingModule,MatRadioModule,

    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCgAi5YLOQS7-tV6hsCFKNL7y4zL0YZ6c0',
      libraries: ['places', 'drawing', 'geometry', 'visualization'],

    })
    
  ],
  providers: [MatDatepickerModule, DatePipe ],
  bootstrap: [AppComponent]
})
export class AppModule { }
